/**
 * Utility functions for checking empty values
 */ /**
 * Checks if a value is considered "empty".
 * Returns true for: null, undefined, empty string, empty array, empty object
 *
 * @param value - The value to check
 * @returns true if the value is empty, false otherwise
 *
 * @example
 * isEmpty(null) // true
 * isEmpty("") // true
 * isEmpty([]) // true
 * isEmpty({}) // true
 * isEmpty("hello") // false
 * isEmpty([1, 2]) // false
 * isEmpty({ key: "value" }) // false
 */ function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
export var isEmpty = function(value) {
    if (value == null) return true;
    if (value === "") return true;
    if (Array.isArray(value)) return value.length === 0;
    if ((typeof value === "undefined" ? "undefined" : _type_of(value)) === "object" && !Array.isArray(value)) {
        return Object.keys(value).length === 0;
    }
    return false;
};
/**
 * Checks if a value is NOT empty.
 * Inverse of isEmpty().
 *
 * @param value - The value to check
 * @returns true if the value is not empty, false otherwise
 */ export var isNotEmpty = function(value) {
    return !isEmpty(value);
};

//# sourceMappingURL=empty.js.map